import { getKeys } from 'shared/lib/object';
import { useCallback } from 'react';
import classNames from 'classnames';

import { getCheckboxName, isAllMonthChecked, isAllMonthDisabled } from './lib';
import type { FormattedHolidays } from './model';
import { GroupCheckbox } from './GroupCheckbox';
import { useHolidaysActions } from './store/store';
import { monthsShortToFull } from './constants';
import { Day } from './Day';

interface MonthProps {
  className?: string;
  holidays: FormattedHolidays;
  year: string;
  month: string;
  shouldScrollToElement?: boolean;
}

export function Month({ className, holidays, year, month, shouldScrollToElement }: MonthProps) {
  const isMonthChecked = isAllMonthChecked(holidays, year, month);
  const isMonthDisabled = isAllMonthDisabled(holidays, year, month);
  const { setMonthIsChecked } = useHolidaysActions();
  const name = getCheckboxName(year, month);

  const onRefChange = useCallback((node: Element | null) => {
    if (node === null) {
      return;
    }

    // we need to scroll to the element after it is rendered on the screen
    setTimeout(() => {
      if (shouldScrollToElement) {
        node.scrollIntoView();
      }
    });
  }, []);

  return (
    <div
      className={classNames('scroll-m-[80px]', className)}
      ref={onRefChange}
    >
      <GroupCheckbox
        name={name}
        className="mt-8"
        isChecked={isMonthChecked}
        onClick={() => setMonthIsChecked({ year, month, isChecked: !isMonthChecked })}
        isDisabled={isMonthDisabled}
      >
        <div className="text-lg font-semibold">{monthsShortToFull[month]}</div>
      </GroupCheckbox>
      {getKeys(holidays[year][month]).map((day) => {
        const item = holidays[year][month][day];

        return (
          <Day
            className="mt-[9px]"
            holiday={item}
            key={day}
          />
        );
      })}
    </div>
  );
}
